/* ============================================================================
FILE: po-axis-miroirs-posoennoiaux-texts-fr-en-es-20260202.js
MODE: TwinLang FR/EN/ES via localStorage + lexicon injection
API:  window.PoAxisMiroirsPosoennoiauxTextsFR_EN_ES_20260202
ROOT: .po-axis-section[data-po-axis]
ROLE:
  - Langue pilotée par localStorage (FR / EN / ES) via boutons.
  - Ré-injecte le contenu trilingue (fallback + lexique si dispo) dans les slots.
  - Bloc protégé des traductions extérieures ; les entrées canoniques restent en français.
  - Ajoute une lecture audio générale puis locale par bloc, sans casser la logique existante.
  - Ciblage strict : uniquement les blocs Miroirs posœnnoïaux.
============================================================================ */
(function(){
  "use strict";

  if (window.__PO_AXIS_MIROIRS_POSOENNOIAUX_TEXTS_20260202__) return;
  window.__PO_AXIS_MIROIRS_POSOENNOIAUX_TEXTS_20260202__ = true;

  var STORAGE_KEY = "po_lex_lang";
  var STORAGE_KEY_COMPAT = "goody_gp_lang";
  var ROOT_SEL = ".po-axis-section[data-po-axis]";

  var CHIP_CONCEPT_URL  = "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/miroir_Posoennoial_2_100x100.png?v=1746287626";
  var CHIP_FUNCTION_URL = "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/miroir_Posoennoial_modalite_2_100x100.png?v=1746287626";
  var CHIP_GUIDE_URL    = "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Nombre_guide_31_100x100.png?v=1751521422";

  function clampStr(v){ return (v == null) ? "" : String(v); }

  function normLang(raw){
    var s = clampStr(raw).toLowerCase().trim().replace(/_/g, "-");
    if (s === "fr" || s.indexOf("fr") === 0) return "fr";
    if (s === "en" || s.indexOf("en") === 0) return "en";
    if (s === "es" || s.indexOf("es") === 0 || s.indexOf("pt") === 0) return "es";
    return "fr";
  }

  function normId(raw){
    return clampStr(raw).toLowerCase().trim().replace(/_/g, "-");
  }

  function isTargetRoot(root){
    if (!root || !root.getAttribute) return false;
    var axis = normId(root.getAttribute("data-po-axis"));
    var id = normId(root.getAttribute("data-po-lex-id"));
    return (
      axis === "miroirs-posoennoiaux" ||
      axis === "miroirs-posœnnoïaux" ||
      id === "miroirs-posoennoiaux" ||
      id === "miroirs-posœnnoïaux" ||
      id === "miroirs-posoennoiaux-31" ||
      id === "miroirs-posœnnoïaux-31"
    );
  }

  function getTargetRoots(){
    var nodes = document.querySelectorAll(ROOT_SEL);
    var out = [];
    for (var i=0;i<nodes.length;i++) if (isTargetRoot(nodes[i])) out.push(nodes[i]);
    return out;
  }

  function readStoredLang(){
    var v = "";
    try{ v = localStorage.getItem(STORAGE_KEY) || ""; }catch(e){ v = ""; }
    if (!v){
      try{ v = localStorage.getItem(STORAGE_KEY_COMPAT) || ""; }catch(_e){ v = ""; }
    }
    return v ? normLang(v) : "";
  }

  function storeLang(lang){
    var l = normLang(lang);
    try{ localStorage.setItem(STORAGE_KEY, l); }catch(e){}
    try{ localStorage.setItem(STORAGE_KEY_COMPAT, l); }catch(_e){}
    try{ document.documentElement.setAttribute("lang", l); }catch(__e){}
    return l;
  }

  function getLang(){
    var s = readStoredLang();
    if (s) return s;
    var dl = (document && document.documentElement) ? (document.documentElement.getAttribute("lang") || "") : "";
    if (dl) return normLang(dl);
    return "fr";
  }

  function notifyLocaleChanged(){
    try{ window.dispatchEvent(new Event("po:locale-changed")); }
    catch(e){
      try{
        var ev = document.createEvent("Event");
        ev.initEvent("po:locale-changed", true, true);
        window.dispatchEvent(ev);
      }catch(_e){}
    }
  }

  function getLexiconEntry(id){
    var target = normId(id);
    try{
      if (window.PO_LEXICON_MAP){
        if (window.PO_LEXICON_MAP[id]) return window.PO_LEXICON_MAP[id];
        for (var k in window.PO_LEXICON_MAP){
          if (window.PO_LEXICON_MAP.hasOwnProperty(k) && normId(k) === target) return window.PO_LEXICON_MAP[k];
        }
      }
    }catch(e){}
    try{
      var arr = window.PO_LEXICON;
      if (Array.isArray(arr)){
        for (var i=0;i<arr.length;i++){
          if (arr[i] && normId(arr[i].id) === target) return arr[i];
        }
      }
    }catch(e){}
    return null;
  }

  function pickTermFR(entry){
    if (!entry) return "";
    try{ if (entry.terms && entry.terms.fr) return clampStr(entry.terms.fr); }catch(e){}
    try{ if (entry.term_fr) return clampStr(entry.term_fr); }catch(_e){}
    return "";
  }

  function pickDefShort(entry, lang){
    if (!entry) return "";
    var ks = "definition_short_" + lang;
    var k  = "definition_" + lang;
    try{
      if (entry[ks]) return clampStr(entry[ks]);
      if (entry[k])  return clampStr(entry[k]);
      if (entry.defs && entry.defs[lang] && entry.defs[lang].short) return clampStr(entry.defs[lang].short);
    }catch(e){}
    return "";
  }

  function pickDefLong(entry, lang){
    if (!entry) return "";
    var kl = "definition_long_" + lang;
    var k  = "definition_" + lang;
    try{
      if (entry[kl]) return clampStr(entry[kl]);
      if (entry[k])  return clampStr(entry[k]);
      if (entry.defs && entry.defs[lang] && entry.defs[lang].long) return clampStr(entry.defs[lang].long);
    }catch(e){}
    return "";
  }

  function pickArray(entry, lang, base){
    if (!entry) return [];
    var k = base + "_" + lang;
    try{ var v = entry[k]; if (Array.isArray(v)) return v; }catch(e){}
    return [];
  }

  function pickAny(entry, key, fallback){
    try{ if (entry && entry[key] != null) return entry[key]; }catch(e){}
    return fallback;
  }

  function escapeRegExp(s){
    return String(s).replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  }

  function uniqPush(arr, v, seen){
    var key = String(v || "");
    if (!key || seen[key]) return;
    seen[key] = true;
    arr.push(key);
  }

  function buildVariants(term){
    var out = [];
    var seen = Object.create(null);
    var t = clampStr(term);
    if (!t) return out;
    uniqPush(out, t, seen);
    uniqPush(out, t.replace(/’/g, "'"), seen);
    uniqPush(out, t.replace(/'/g, "’"), seen);
    uniqPush(out, t.replace(/œ/g, "oe").replace(/Œ/g, "OE"), seen);
    uniqPush(out, t.replace(/oe/g, "œ").replace(/OE/g, "Œ"), seen);
    var oe1 = t.replace(/œ/g, "oe").replace(/Œ/g, "OE");
    var oe2 = t.replace(/oe/g, "œ").replace(/OE/g, "Œ");
    uniqPush(out, oe1.replace(/’/g, "'"), seen);
    uniqPush(out, oe1.replace(/'/g, "’"), seen);
    uniqPush(out, oe2.replace(/’/g, "'"), seen);
    uniqPush(out, oe2.replace(/'/g, "’"), seen);
    return out;
  }

  function getCanonicalProtectTerms(){
    var base = [
      "Miroirs posœnnoïaux",
      "Posœnnoïsme",
      "Posœnnoïal",
      "Posœnnoïale",
      "Posœnnoïaux",
      "Posœnnoïales",
      "Posœnnoïa",
      "Katûpirsia",
      "RéZonans",
      "Aliœvolution",
      "Péroptissimisme",
      "Illusion",
      "Instantané multiple",
      "Superposition de perspectives",
      "Sujet pluriel",
      "Expérience fragmentée",
      "Stratification d’expériences",
      "Myrte décisif",
      "Méditations posœnnoïales",
      "Accords posœnnoïaux"
    ];
    try{
      if (window.PO_LEXICON_META && Array.isArray(window.PO_LEXICON_META.lexique_simplifie_fr)){
        var frList = window.PO_LEXICON_META.lexique_simplifie_fr;
        for (var i=0;i<frList.length;i++) base.push(frList[i]);
      }
    }catch(e){}
    var all = [];
    var seen = Object.create(null);
    for (var j=0;j<base.length;j++){
      var vars = buildVariants(base[j]);
      for (var k=0;k<vars.length;k++) uniqPush(all, vars[k], seen);
    }
    all.sort(function(a,b){ return b.length - a.length; });
    return all;
  }

  var CANONICAL_TERMS = getCanonicalProtectTerms();

  function protectSpan(txt){
    return '<span translate="no" class="po-lex-protect notranslate" data-po-protect="1">' + clampStr(txt) + '</span>';
  }

  function protectKeywordsHTML(html){
    var src = clampStr(html);
    if (!src) return "";
    var placeholders = [];
    src = src.replace(/<[^>]+>/g, function(tag){
      var key = "%%PO_TAG_" + placeholders.length + "%%";
      placeholders.push(tag);
      return key;
    });
    for (var i=0;i<CANONICAL_TERMS.length;i++){
      var term = CANONICAL_TERMS[i];
      if (!term) continue;
      var re = new RegExp(escapeRegExp(term), "g");
      src = src.replace(re, function(){ return protectSpan(term); });
    }
    src = src.replace(/%%PO_TAG_(\d+)%%/g, function(_, idx){
      return placeholders[parseInt(idx, 10)] || "";
    });
    return src;
  }

  function lockSlotNode(node){
    if (!node || node.__poLockDone) return;
    try{ node.setAttribute("translate", "no"); }catch(e){}
    if (node.classList && !node.classList.contains("notranslate")) node.classList.add("notranslate");
    node.__poLockDone = true;
  }

  function setSlotText(root, slot, txt){
    var el = root.querySelector("[data-po-slot='" + slot + "']");
    if (!el) return;
    lockSlotNode(el);
    el.textContent = clampStr(txt);
  }

  function setSlotHTML(root, slot, html){
    var el = root.querySelector("[data-po-slot='" + slot + "']");
    if (!el) return;
    lockSlotNode(el);
    el.innerHTML = protectKeywordsHTML(clampStr(html));
  }

  function setSlotImgSrc(root, slot, src, alt){
    var el = root.querySelector("[data-po-slot='" + slot + "']");
    if (!el) return;
    el.setAttribute("src", clampStr(src));
    el.setAttribute("alt", clampStr(alt));
  }

  function renderListInto(root, slot, items){
    var el = root.querySelector("[data-po-slot='" + slot + "']");
    if (!el) return;
    lockSlotNode(el);
    el.innerHTML = "";
    for (var i=0;i<(items||[]).length;i++){
      var li = document.createElement("li");
      li.innerHTML = protectKeywordsHTML(clampStr(items[i]));
      el.appendChild(li);
    }
  }

  function renderWordBlocks(root, slot, blocks){
    var host = root.querySelector("[data-po-slot='" + slot + "']");
    if (!host) return;
    lockSlotNode(host);
    host.innerHTML = "";
    for (var i=0;i<(blocks||[]).length;i++){
      var b = blocks[i] || {};
      var wrap = document.createElement("div");
      wrap.className = "po-axis-wb";
      var h = document.createElement("div");
      h.className = "po-axis-wb__h";
      h.innerHTML = protectKeywordsHTML(clampStr(b.head || ""));
      var t = document.createElement("div");
      t.className = "po-axis-wb__t";
      t.innerHTML = protectKeywordsHTML(clampStr(b.text || ""));
      wrap.appendChild(h);
      wrap.appendChild(t);
      host.appendChild(wrap);
    }
  }

  function setPressed(root, lang){
    var btns = root.querySelectorAll(".po-lex-btn[data-po-lang]");
    for (var i=0;i<btns.length;i++){
      var b = btns[i];
      var k = normLang(b.getAttribute("data-po-lang"));
      var on = (k === lang);
      b.setAttribute("aria-pressed", on ? "true" : "false");
      if (b.classList && b.classList.toggle) b.classList.toggle("is-active", !!on);
    }
  }

  function bindLangButtons(root){
    if (!root) return;
    var bar = root.querySelector("[data-po-lang-switch], .po-lex-langbar, .po-lex-lang");
    if (bar){
      var ui = audioUI(getLang());
      if (!bar.getAttribute("aria-label")) bar.setAttribute("aria-label", ui.langbar);
    }
    var btns = root.querySelectorAll(".po-lex-btn[data-po-lang]");
    for (var i=0;i<btns.length;i++){
      var btn = btns[i];
      if (btn.__poLangBound) continue;
      btn.addEventListener("click", function(ev){
        ev.preventDefault();
        applyLangEverywhere(normLang(this.getAttribute("data-po-lang")));
      });
      btn.__poLangBound = true;
    }
  }

  var AUDIO_UI = {
    fr: { general: "Écouter le texte", block: "Écouter ce bloc", stop: "Arrêter la lecture", unavailable: "Audio indisponible", langbar: "Choisir la langue" },
    en: { general: "Listen to the text", block: "Listen to this section", stop: "Stop playback", unavailable: "Audio unavailable", langbar: "Choose language" },
    es: { general: "Escuchar el texto", block: "Escuchar este bloque", stop: "Detener la lectura", unavailable: "Audio no disponible", langbar: "Elegir idioma" }
  };

  function audioUI(lang){ return AUDIO_UI[normLang(lang)] || AUDIO_UI.fr; }
  function speechLang(lang){ var L = normLang(lang); if (L === "en") return "en-US"; if (L === "es") return "es-ES"; return "fr-FR"; }

  var PO_AUDIO_SYNTH = (typeof window !== "undefined" && window.speechSynthesis) ? window.speechSynthesis : null;
  var PO_AUDIO_STATE = { root: null, queue: [], runId: 0, activeKey: "", activeButton: null };

  function ensureAudioStyles(){
    if (!document || !document.head) return;
    if (document.getElementById("po-axis-miroirs-posoennoiaux-audio-style-20260202")) return;
    var style = document.createElement("style");
    style.id = "po-axis-miroirs-posoennoiaux-audio-style-20260202";
    style.textContent =
      '.po-axis-audio-wrap{display:flex;justify-content:center;align-items:center;margin:10px 0 12px;}' +
      '.po-axis-audio-btn,.po-axis-section[data-po-lex-id="miroirs_posoennoiaux"] .po-audio-inline-btn,.po-axis-section[data-po-lex-id="miroirs-posoennoiaux"] .po-audio-inline-btn,.po-axis-section[data-po-lex-id="miroirs_posœnnoïaux"] .po-audio-inline-btn,.po-axis-section[data-po-lex-id="miroirs-posœnnoïaux"] .po-audio-inline-btn{' +
      'appearance:none;border:1px solid rgba(0,0,0,.12);background:rgba(0,0,0,.03);color:inherit;border-radius:999px;padding:8px 12px;font:inherit;font-size:12px;font-weight:700;line-height:1.2;cursor:pointer;display:inline-flex;align-items:center;justify-content:center;gap:6px;white-space:nowrap;transition:transform .18s ease, background .18s ease, border-color .18s ease;}' +
      '.po-axis-audio-btn:hover,.po-axis-section[data-po-lex-id="miroirs_posoennoiaux"] .po-audio-inline-btn:hover,.po-axis-section[data-po-lex-id="miroirs-posoennoiaux"] .po-audio-inline-btn:hover,.po-axis-section[data-po-lex-id="miroirs_posœnnoïaux"] .po-audio-inline-btn:hover,.po-axis-section[data-po-lex-id="miroirs-posœnnoïaux"] .po-audio-inline-btn:hover{transform:translateY(-1px);border-color:rgba(0,0,0,.22);background:rgba(0,0,0,.05);}' +
      '.po-axis-audio-btn.is-playing,.po-axis-section[data-po-lex-id="miroirs_posoennoiaux"] .po-audio-inline-btn.is-playing,.po-axis-section[data-po-lex-id="miroirs-posoennoiaux"] .po-audio-inline-btn.is-playing,.po-axis-section[data-po-lex-id="miroirs_posœnnoïaux"] .po-audio-inline-btn.is-playing,.po-axis-section[data-po-lex-id="miroirs-posœnnoïaux"] .po-audio-inline-btn.is-playing{border-color:rgba(0,0,0,.3);background:rgba(0,0,0,.08);}' +
      '.po-axis-audio-btn[disabled],.po-axis-section[data-po-lex-id="miroirs_posoennoiaux"] .po-audio-inline-btn[disabled],.po-axis-section[data-po-lex-id="miroirs-posoennoiaux"] .po-audio-inline-btn[disabled],.po-axis-section[data-po-lex-id="miroirs_posœnnoïaux"] .po-audio-inline-btn[disabled],.po-axis-section[data-po-lex-id="miroirs-posœnnoïaux"] .po-audio-inline-btn[disabled]{opacity:.5;cursor:not-allowed;transform:none;}' +
      '.po-axis-section[data-po-lex-id="miroirs_posoennoiaux"] .po-lex-summary,.po-axis-section[data-po-lex-id="miroirs-posoennoiaux"] .po-lex-summary,.po-axis-section[data-po-lex-id="miroirs_posœnnoïaux"] .po-lex-summary,.po-axis-section[data-po-lex-id="miroirs-posœnnoïaux"] .po-lex-summary{display:flex;align-items:center;gap:10px;}' +
      '.po-axis-section[data-po-lex-id="miroirs_posoennoiaux"] .po-lex-summary__hint,.po-axis-section[data-po-lex-id="miroirs-posoennoiaux"] .po-lex-summary__hint,.po-axis-section[data-po-lex-id="miroirs_posœnnoïaux"] .po-lex-summary__hint,.po-axis-section[data-po-lex-id="miroirs-posœnnoïaux"] .po-lex-summary__hint{margin-left:auto;}' +
      '@media (max-width:760px){.po-axis-section[data-po-lex-id="miroirs_posoennoiaux"] .po-lex-summary,.po-axis-section[data-po-lex-id="miroirs-posoennoiaux"] .po-lex-summary,.po-axis-section[data-po-lex-id="miroirs_posœnnoïaux"] .po-lex-summary,.po-axis-section[data-po-lex-id="miroirs-posœnnoïaux"] .po-lex-summary{flex-wrap:wrap;}.po-axis-section[data-po-lex-id="miroirs_posoennoiaux"] .po-lex-summary__hint,.po-axis-section[data-po-lex-id="miroirs-posoennoiaux"] .po-lex-summary__hint,.po-axis-section[data-po-lex-id="miroirs_posœnnoïaux"] .po-lex-summary__hint,.po-axis-section[data-po-lex-id="miroirs-posœnnoïaux"] .po-lex-summary__hint{margin-left:0;}}';
    document.head.appendChild(style);
  }

  function normalizeSpeechText(text){
    return clampStr(text).replace(/\u00A0/g, " ").replace(/\s+/g, " ").replace(/\s+([,;:.!?])/g, "$1").trim();
  }

  function splitSpeechChunks(text){
    var clean = normalizeSpeechText(text);
    if (!clean) return [];
    var raw = clean.match(/[^.!?;:]+[.!?;:]*/g) || [clean];
    var chunks = [];
    var current = "";
    function pushChunk(chunk){ var c = normalizeSpeechText(chunk); if (c) chunks.push(c); }
    function splitLongSentence(sentence){
      var rest = normalizeSpeechText(sentence);
      while (rest.length > 220){
        var cut = rest.lastIndexOf(" ", 220);
        if (cut < 120) cut = 220;
        pushChunk(rest.slice(0, cut));
        rest = normalizeSpeechText(rest.slice(cut));
      }
      pushChunk(rest);
    }
    for (var i=0;i<raw.length;i++){
      var sentence = normalizeSpeechText(raw[i]);
      if (!sentence) continue;
      if (sentence.length > 220){
        if (current){ pushChunk(current); current = ""; }
        splitLongSentence(sentence);
        continue;
      }
      var proposal = current ? (current + " " + sentence) : sentence;
      if (proposal.length > 220){ pushChunk(current); current = sentence; }
      else current = proposal;
    }
    if (current) pushChunk(current);
    return chunks;
  }

  function extractReadableText(node){
    if (!node) return "";
    var txt = "";
    if (typeof node.innerText === "string" && node.innerText) txt = node.innerText;
    else txt = node.textContent || "";
    return normalizeSpeechText(txt);
  }

  function collectGeneralSpeech(root){
    var parts = [];
    var slots = ["title", "kicker", "h_def", "def_short", "def_long"];
    for (var i=0;i<slots.length;i++){
      var el = root.querySelector("[data-po-slot='" + slots[i] + "']");
      var txt = extractReadableText(el);
      if (txt) parts.push(txt);
    }
    return parts.join(". ");
  }

  function collectDetailsSpeech(details){
    if (!details) return "";
    var parts = [];
    var title = details.querySelector(".po-lex-summary__title");
    var titleText = extractReadableText(title);
    if (titleText) parts.push(titleText);
    var children = details.children || [];
    for (var i=0;i<children.length;i++){
      var child = children[i];
      if (!child || !child.tagName) continue;
      if (child.tagName.toLowerCase() === "summary") continue;
      var text = extractReadableText(child);
      if (text) parts.push(text);
    }
    return parts.join(". ");
  }

  function createAudioButton(kind, lang){
    var btn = document.createElement("button");
    btn.type = "button";
    btn.className = (kind === "general") ? "po-axis-audio-btn" : "po-audio-inline-btn";
    var ui = audioUI(lang);
    btn.textContent = (kind === "general") ? ui.general : ui.block;
    btn.setAttribute("aria-label", btn.textContent);
    return btn;
  }

  function ensureAudioButtons(root, lang){
    if (!root) return;
    ensureAudioStyles();
    var ui = audioUI(lang);
    var panel = root.querySelector(".po-lex-panel");
    if (panel){
      var generalWrap = root.querySelector(".po-axis-audio-wrap[data-po-audio-role='general']");
      if (!generalWrap){
        generalWrap = document.createElement("div");
        generalWrap.className = "po-axis-audio-wrap";
        generalWrap.setAttribute("data-po-audio-role", "general");
        var generalBtn = createAudioButton("general", lang);
        generalBtn.setAttribute("data-po-audio-kind", "general");
        generalWrap.appendChild(generalBtn);
        var meta = root.querySelector(".po-axis-meta");
        var defShort = root.querySelector("[data-po-slot='def_short']");
        var firstDetails = root.querySelector(".po-lex-details");
        if (meta && meta.parentNode === panel) meta.insertAdjacentElement("afterend", generalWrap);
        else if (defShort && defShort.parentNode === panel) defShort.insertAdjacentElement("beforebegin", generalWrap);
        else if (firstDetails && firstDetails.parentNode === panel) firstDetails.insertAdjacentElement("beforebegin", generalWrap);
        else panel.insertBefore(generalWrap, panel.firstChild);
      }
      var gbtn = generalWrap.querySelector(".po-axis-audio-btn");
      if (gbtn){
        gbtn.textContent = ui.general;
        gbtn.setAttribute("aria-label", ui.general);
        if (!gbtn.__poAudioBound){
          gbtn.addEventListener("click", function(ev){
            ev.preventDefault();
            if (PO_AUDIO_STATE.root === root && PO_AUDIO_STATE.activeKey === "general"){ stopAudio(); return; }
            startAudioFromGeneral(root);
          });
          gbtn.__poAudioBound = true;
        }
      }
    }
    var details = root.querySelectorAll(".po-lex-details");
    for (var i=0;i<details.length;i++){
      var summary = details[i].querySelector("summary.po-lex-summary");
      if (!summary) continue;
      var btn = summary.querySelector(".po-audio-inline-btn");
      if (!btn){
        btn = createAudioButton("detail", lang);
        btn.setAttribute("data-po-audio-kind", "detail");
        summary.appendChild(btn);
      }
      btn.textContent = ui.block;
      btn.setAttribute("aria-label", ui.block);
      btn.setAttribute("data-po-audio-index", String(i));
      if (!btn.__poAudioBound){
        btn.addEventListener("click", function(ev){
          ev.preventDefault();
          ev.stopPropagation();
          var idx = parseInt(this.getAttribute("data-po-audio-index") || "0", 10);
          if (PO_AUDIO_STATE.root === root && PO_AUDIO_STATE.activeKey === ("detail:" + idx)){ stopAudio(); return; }
          startAudioFromDetail(root, idx);
        });
        btn.__poAudioBound = true;
      }
    }
    refreshAudioButtons();
  }

  function refreshAudioButtons(){
    var roots = getTargetRoots();
    for (var i=0;i<roots.length;i++){
      var root = roots[i];
      var lang = getLang();
      var ui = audioUI(lang);
      var general = root.querySelector(".po-axis-audio-btn");
      if (general){
        var gActive = (PO_AUDIO_STATE.root === root && PO_AUDIO_STATE.activeKey === "general");
        general.textContent = gActive ? ui.stop : ui.general;
        general.setAttribute("aria-label", gActive ? ui.stop : ui.general);
        general.classList.toggle("is-playing", !!gActive);
        if (!PO_AUDIO_SYNTH){ general.disabled = true; general.title = ui.unavailable; }
        else { general.disabled = false; general.title = gActive ? ui.stop : ui.general; }
      }
      var detailButtons = root.querySelectorAll(".po-audio-inline-btn[data-po-audio-index]");
      for (var j=0;j<detailButtons.length;j++){
        var btn = detailButtons[j];
        var key = "detail:" + (btn.getAttribute("data-po-audio-index") || "0");
        var active = (PO_AUDIO_STATE.root === root && PO_AUDIO_STATE.activeKey === key);
        btn.textContent = active ? ui.stop : ui.block;
        btn.setAttribute("aria-label", active ? ui.stop : ui.block);
        btn.classList.toggle("is-playing", !!active);
        if (!PO_AUDIO_SYNTH){ btn.disabled = true; btn.title = ui.unavailable; }
        else { btn.disabled = false; btn.title = active ? ui.stop : ui.block; }
      }
    }
  }

  function stopAudio(){
    PO_AUDIO_STATE.runId += 1;
    PO_AUDIO_STATE.root = null;
    PO_AUDIO_STATE.queue = [];
    PO_AUDIO_STATE.activeKey = "";
    PO_AUDIO_STATE.activeButton = null;
    if (PO_AUDIO_SYNTH){
      try{ if (PO_AUDIO_SYNTH.speaking || PO_AUDIO_SYNTH.pending) PO_AUDIO_SYNTH.cancel(); }catch(e){}
    }
    refreshAudioButtons();
  }

  function speakChunksSequentially(chunks, lang, runId, done){
    if (!PO_AUDIO_SYNTH || !chunks || !chunks.length){ if (typeof done === "function") done(); return; }
    var idx = 0;
    function next(){
      if (runId !== PO_AUDIO_STATE.runId) return;
      if (idx >= chunks.length){ if (typeof done === "function") done(); return; }
      var utt = new SpeechSynthesisUtterance(chunks[idx]);
      utt.lang = speechLang(lang);
      utt.rate = 0.96;
      utt.onend = function(){ idx += 1; next(); };
      utt.onerror = function(){ idx += 1; next(); };
      try{ PO_AUDIO_SYNTH.speak(utt); }catch(e){ idx += 1; next(); }
    }
    next();
  }

  function playQueue(runId){
    if (runId !== PO_AUDIO_STATE.runId) return;
    if (!PO_AUDIO_STATE.queue.length){ stopAudio(); return; }
    var item = PO_AUDIO_STATE.queue.shift();
    if (!item || !item.root || !document.body.contains(item.root)){ playQueue(runId); return; }
    var root = item.root;
    var lang = getLang();
    PO_AUDIO_STATE.root = root;
    PO_AUDIO_STATE.activeKey = item.key;
    refreshAudioButtons();
    if (item.details) item.details.open = true;
    var text = item.collect();
    var chunks = splitSpeechChunks(text);
    speakChunksSequentially(chunks, lang, runId, function(){ playQueue(runId); });
  }

  function buildDetailQueue(root, startIndex){
    var queue = [];
    var details = root.querySelectorAll(".po-lex-details");
    for (var i=startIndex;i<details.length;i++){
      (function(detailsNode, idx){
        queue.push({ root: root, key: "detail:" + idx, details: detailsNode, collect: function(){ return collectDetailsSpeech(detailsNode); } });
      })(details[i], i);
    }
    return queue;
  }

  function startAudioFromGeneral(root){
    if (!root) return;
    stopAudio();
    PO_AUDIO_STATE.runId += 1;
    var runId = PO_AUDIO_STATE.runId;
    PO_AUDIO_STATE.root = root;
    PO_AUDIO_STATE.activeKey = "general";
    PO_AUDIO_STATE.queue = [{ root: root, key: "general", details: null, collect: function(){ return collectGeneralSpeech(root); } }].concat(buildDetailQueue(root, 0));
    playQueue(runId);
  }

  function startAudioFromDetail(root, idx){
    if (!root) return;
    stopAudio();
    PO_AUDIO_STATE.runId += 1;
    var runId = PO_AUDIO_STATE.runId;
    PO_AUDIO_STATE.queue = buildDetailQueue(root, idx);
    playQueue(runId);
  }

  var FALLBACK = {
    fr: {
      title: "Miroirs posœnnoïaux",
      kicker: "Modalité opérative — Extrait du corpus posœnnoïal",
      h_def: "Définition opérative",
      chips: ["Idéogramme conceptuel", "Idéogramme fonctionnel", "Nombre guide"],
      chip_urls: [CHIP_CONCEPT_URL, CHIP_FUNCTION_URL, CHIP_GUIDE_URL],
      def_short: "Dispositifs vibratoires de réverbération entre le visible et l’invisible, conçus pour rendre perceptible le devenir du Sujet pluriel à travers l’ensemble des reflets symboliques, temporels et internes que le réel met en résonance.",
      def_long: "Les Miroirs posœnnoïaux sont une passerelle vibratoire entre le visible et l’invisible, entre ce qui se perçoit directement et ce qui ne se saisit qu’à travers ses reflets.\n\nIls ne sont pas de simples images : ce sont des structures de résonance indirecte. Ils révèlent non pas le réel “tel qu’il est”, mais ce qu’il dévoile par diffraction : l’écho des possibles en transformation.\n\nIls permettent au Sujet pluriel d’entrer en contact avec des formes émergentes de lui-même et de son environnement, via des objets, situations, synchronicités, signes symboliques. Internes autant qu’externes, ils agissent comme catalyseurs de conscience évolutive : ils ne projettent pas, ils révèlent par différenciation ce qui s’ajuste entre les couches du réel et les modulations internes.\n\nUn silence soudain dans une conversation, une image récurrente, la résonance inattendue d’un texte : autant de miroirs où ce qui se montre n’est pas un passé, mais une vibration du devenir.",
      h_features: "Repères structurants",
      h_questions: "Repères d’activation",
      hint_fold: "déplier",
      example_title: "Ex.",
      example: "Observer un signe (silence, motif, coïncidence), suspendre la projection (Illusion), écouter ce que le reflet fait vibrer (RéZonans), puis intégrer l’altérité révélée (Aliœvolution) et transformer la confrontation en levier (Péroptissimisme).",
      features: ["Réverbération : le miroir rend perceptible un devenir par écho, non par image brute.", "Diffraction : il révèle des possibles en transformation plutôt qu’un état figé.", "Interne/Externe : il agit via signes, objets, situations, mais aussi dans les couches du Sujet pluriel.", "Non-projection : discerner sans plaquer une interprétation automatique (Illusion).", "Traduction symbolique : il transforme une vibration contextuelle en forme lisible.", "Catalyse : il accélère la conscience évolutive en rendant visibles des strates émergentes."],
      questions: ["Qu’est-ce que ce reflet me montre de ce que je deviens (plutôt que de ce que j’étais) ?", "Quel élément, ici, relève de la projection (Illusion) — et quel élément relève d’un signal (RéZonans) ?", "Quelles strates du Sujet pluriel ce miroir met-il en résonance ou en conflit ?", "Quelle altérité ce miroir révèle-t-il, et comment l’intégrer sans dilution (Aliœvolution) ?", "Quelle tension puis-je transmuter à partir de ce reflet (Péroptissimisme) ?"],
      h_family: "Affinités posœnnoïales",
      family_1: "<p><strong>Piliers activés :</strong> Illusion (perception indirecte, discernement sans projection), RéZonans (capter la résonance d’un reflet), Aliœvolution (intégrer l’altérité révélée), Péroptissimisme (faire de la confrontation un levier d’évolution).</p>",
      family_2: "<p><strong>Outils mobilisés :</strong> Instantané multiple (voir plusieurs niveaux de reflet), Sujet pluriel (reconnaître la multiplicité en jeu), Superposition de perspectives (interpréter sous des angles complémentaires). En proximité : <strong>Expérience fragmentée</strong> / <strong>Stratification d’expériences</strong> (couches du vécu), <strong>Myrte décisif</strong> (un reflet peut déclencher une décision alignée).</p>",
      h_wordbuild: "Positionnements & comparaisons",
      word_blocks: [{ head: "Lacan — stade du miroir", text: "Chez Lacan, le miroir stabilise une image du moi par identification. Ici, le miroir est évolutif : il ne fige pas, il rend perceptible une trajectoire en mutation, par diffraction." }, { head: "Jung — ombre et projections", text: "L’autre comme miroir de l’inconscient. Intégré, mais élargi : le miroir est aussi symbolique, environnemental, temporel — au-delà de la seule introspection." }, { head: "Hermétisme — correspondances", text: "Le monde comme réseau de miroirs analogiques. Affinité, mais avec une dynamique plus mobile : reflets paradoxaux, écarts, résonances inattendues, non symétriques." }, { head: "Symbolisme / surréalisme", text: "L’œuvre comme miroir de l’invisible. Très proche : le miroir poïétique révèle non une vérité déjà-là, mais une vibration émergente." }, { head: "Esthétique phénoménologique", text: "Ce qui apparaît dévoile la conscience. Ici, on inclut aussi le silence, l’absence, la diffraction : ce qui ne se donne pas directement devient matière valide du miroir." }, { head: "Modalités et éléments proches", text: "Illusion : filtre à traverser ; le miroir révèle un devenir. RéZonans : capte ; le miroir traduit en forme symbolique. Instantané multiple : superpose ; le miroir diffracte. Superposition : analytique ; le miroir est plus intuitif. Sujet pluriel : structure ; le miroir révèle. Expérience fragmentée / Stratification : structurent les couches ; le miroir reflète sans figer. Myrte décisif : le miroir peut préparer un basculement aligné." }],
      word_notes: ["Nombre-guide 31 : création / expression (3) + initiative / axe (1) — “reflets structurants”, où l’émergence devient lisible et orientable.", "Principe : reconnaître le devenir par écho et correspondance, non par constat figé.", "Formule opérative : Illusion déjoue la projection, RéZonans capte, Aliœvolution intègre, Péroptissimisme transmute ; Instantané multiple et Superposition ouvrent la lecture du reflet."],
      cta_translate: "Proposer une traduction du concept"
    },
    en: {
      title: "Miroirs posœnnoïaux",
      kicker: "Operative modality — Excerpt from the Posœnnoïal corpus",
      h_def: "Operative definition",
      chips: ["Concept ideogram", "Functional ideogram", "Guide number 31"],
      chip_urls: [CHIP_CONCEPT_URL, CHIP_FUNCTION_URL, CHIP_GUIDE_URL],
      def_short: "Vibratory devices of reverberation between the visible and the invisible, designed to make the becoming of the Sujet pluriel perceptible through symbolic, temporal, and inner reflections set into resonance by reality.",
      def_long: "Posœnnoïal mirrors form a vibratory bridge between the visible and the invisible—between what is perceived directly and what can only be grasped through its reflections.\n\nThey are not mere images: they operate as structures of indirect resonance. They reveal not reality “as it is” but what it discloses through diffraction—the echo of possibilities in transformation.\n\nThey allow the Sujet pluriel to meet emerging forms of self and environment through objects, situations, synchronicities, and symbolic signs. As internal as they are external, they act as catalysts for evolutive consciousness: they do not project; they reveal, by differentiation, what is adjusting between layers of reality and inner modulations.\n\nA sudden silence in a conversation, a recurring image, an unexpected resonance from a text—these are mirrors in which what shows up is not the past, but a vibration of becoming.",
      h_features: "Structural cues",
      h_questions: "Activation cues",
      hint_fold: "expand",
      example_title: "Ex.",
      example: "Notice a sign (silence, motif, coincidence), suspend projection (Illusion), listen to what the reflection makes vibrate (RéZonans), integrate the revealed otherness (Aliœvolution), and turn confrontation into a lever (Péroptissimisme).",
      features: ["Reverberation: the mirror makes becoming perceptible through echo, not raw image.", "Diffraction: it reveals transforming possibilities rather than a fixed state.", "Internal/External: it acts through signs, objects, situations, and through layers of the Sujet pluriel.", "Non-projection: discern without automatic overlays (Illusion).", "Symbolic translation: it turns contextual vibration into a readable form.", "Catalyst: it accelerates evolutive awareness by making emerging layers visible."],
      questions: ["What does this reflection show about what I am becoming (rather than what I was)?", "What here is projection (Illusion), and what is a signal (RéZonans)?", "Which layers of the Sujet pluriel does this mirror bring into resonance or conflict?", "What otherness does it reveal, and how can I integrate it without dilution (Aliœvolution)?", "Which tension can be transmuted from this reflection (Péroptissimisme)?"],
      h_family: "Posœnnoïal affinities",
      family_1: "<p><strong>Activated pillars:</strong> Illusion (indirect perception, discernment without projection), RéZonans (catch a reflection’s resonance), Aliœvolution (integrate revealed otherness), Péroptissimisme (turn confrontation into evolution).</p>",
      family_2: "<p><strong>Mobilized tools:</strong> Multiple instant (see several reflection layers at once), Sujet pluriel (recognize multiplicity at play), Superposition of perspectives (interpret from complementary angles). Near-by: <strong>Fragmented experience</strong> / <strong>Stratification of experiences</strong>, <strong>Decisive Myrtle</strong> (a mirror can trigger an aligned decision).</p>",
      h_wordbuild: "Positions & comparisons",
      word_blocks: [{ head: "Lacan — mirror stage", text: "In Lacan, the mirror stabilizes the ego through identification. Here, the mirror is evolutive: it does not freeze; it makes a mutating trajectory perceptible through diffraction." }, { head: "Jung — shadow and projections", text: "The other as a mirror of the unconscious. Included, yet expanded: the mirror is also symbolic, environmental, temporal—beyond introspection alone." }, { head: "Hermetic correspondences", text: "The world as a network of analogical mirrors. Affinity, but with added mobility: paradoxical, non-symmetrical reflections, gaps, and unexpected resonances." }, { head: "Symbolism / surrealism", text: "The artwork as a mirror of the invisible. Very close: the poietic mirror reveals not a ready-made truth but an emerging vibration." }, { head: "Phenomenological aesthetics", text: "What appears discloses consciousness. Here we also include silence, absence, diffraction—what does not present itself directly becomes valid mirror-material." }, { head: "Nearby modalities and elements", text: "Illusion: a filter to cross; the mirror reveals becoming. RéZonans: senses; the mirror translates into symbolic form. Multiple instant: superposes; the mirror diffracts. Superposition: analytical; the mirror leans intuitive. Sujet pluriel: structure; the mirror reveals. Fragmented experience / Stratification: structure layers; the mirror reflects without fixing. Decisive Myrtle: the mirror can prepare an aligned turning point." }],
      word_notes: ["Guide number 31: expression/creation (3) + initiative/axis (1)—“structuring reflections” that make emergence readable and orientable.", "Principle: recognize becoming through echo and correspondence, not through a fixed inventory.", "Operative chain: Illusion prevents projection, RéZonans senses, Aliœvolution integrates, Péroptissimisme transmutes; Multiple instant and Superposition open the reading."] ,
      cta_translate: "Suggest a translation of the concept"
    },
    es: {
      title: "Miroirs posœnnoïaux",
      kicker: "Modalidad operativa — Extracto del corpus posœnnoïal",
      h_def: "Definición operativa",
      chips: ["Ideograma conceptual", "Ideograma funcional", "Número guía 31"],
      chip_urls: [CHIP_CONCEPT_URL, CHIP_FUNCTION_URL, CHIP_GUIDE_URL],
      def_short: "Dispositivos vibratorios de reverberación entre lo visible y lo invisible, concebidos para hacer perceptible el devenir del Sujet pluriel mediante reflejos simbólicos, temporales e internos que lo real pone en resonancia.",
      def_long: "Los Espejos posœnnoïales son un puente vibratorio entre lo visible y lo invisible—entre lo que se percibe directamente y lo que solo puede captarse a través de sus reflejos.\n\nNo son simples imágenes: funcionan como estructuras de resonancia indirecta. Revelan no lo real “tal como es”, sino lo que desvela por difracción: el eco de posibles en transformación.\n\nPermiten al Sujet pluriel entrar en contacto con formas emergentes de sí y de su entorno a través de objetos, situaciones, sincronicidades y signos simbólicos. Tan internos como externos, actúan como catalizadores de conciencia evolutiva: no proyectan; revelan, por diferenciación, lo que se ajusta entre capas de lo real y modulaciones internas.\n\nUn silencio súbito en una conversación, una imagen recurrente, la resonancia inesperada de un texto: espejos donde lo que se muestra no es el pasado, sino una vibración del devenir.",
      h_features: "Marcas estructurantes",
      h_questions: "Señales de activación",
      hint_fold: "desplegar",
      example_title: "Ej.",
      example: "Observar un signo (silencio, motivo, coincidencia), suspender la proyección (Illusion), escuchar lo que el reflejo hace vibrar (RéZonans), integrar la alteridad revelada (Aliœvolution) y convertir la confrontación en palanca (Péroptissimisme).",
      features: ["Reverberación: el espejo hace perceptible el devenir por eco, no por imagen bruta.", "Difracción: revela posibles en transformación, no un estado fijo.", "Interno/Externo: actúa por signos, objetos, situaciones y por capas del Sujet pluriel.", "No-proyección: discernir sin superposiciones automáticas (Illusion).", "Traducción simbólica: convierte una vibración contextual en forma legible.", "Catalizador: acelera la conciencia evolutiva haciendo visibles estratos emergentes."],
      questions: ["¿Qué me muestra este reflejo de lo que estoy llegando a ser (más que de lo que fui)?", "¿Qué aquí es proyección (Illusion) y qué es señal (RéZonans)?", "¿Qué capas del Sujet pluriel pone este espejo en resonancia o en conflicto?", "¿Qué alteridad revela y cómo integrarla sin dilución (Aliœvolution)?", "¿Qué tensión puedo transmutar desde este reflejo (Péroptissimisme)?"],
      h_family: "Afinidades posœnnoïales",
      family_1: "<p><strong>Pilares activados:</strong> Illusion (percepción indirecta, discernimiento sin proyección), RéZonans (captar la resonancia del reflejo), Aliœvolution (integrar la alteridad revelada), Péroptissimisme (hacer de la confrontación una evolución).</p>",
      family_2: "<p><strong>Herramientas movilizadas:</strong> Instantáneo múltiple (ver varios niveles a la vez), Sujet pluriel (reconocer la multiplicidad en juego), Superposición de perspectivas (interpretar desde ángulos complementarios). Cercanías: <strong>Experiencia fragmentada</strong> / <strong>Stratification d’expériences</strong>, <strong>Mirto decisivo</strong> (un espejo puede detonar una decisión alineada).</p>",
      h_wordbuild: "Posicionamientos y comparaciones",
      word_blocks: [{ head: "Lacan — estadio del espejo", text: "En Lacan, el espejo estabiliza el yo por identificación. Aquí, el espejo es evolutivo: no fija, hace perceptible una trayectoria en mutación por difracción." }, { head: "Jung — sombra y proyecciones", text: "El otro como espejo del inconsciente. Integrado, pero ampliado: el espejo también es simbólico, ambiental, temporal—más allá de la introspección." }, { head: "Hermetismo — correspondencias", text: "El mundo como red de espejos analógicos. Afinidad, con una dinámica más móvil: reflejos paradójicos, no simétricos, con huecos y resonancias inesperadas." }, { head: "Simbolismo / surrealismo", text: "La obra como espejo de lo invisible. Muy cercano: el espejo poiético revela no una verdad ya dada, sino una vibración emergente." }, { head: "Estética fenomenológica", text: "Lo que aparece revela la conciencia. Aquí se incluye también el silencio, la ausencia, la difracción: lo no directo se vuelve materia válida del espejo." }, { head: "Modalidades y elementos cercanos", text: "Illusion: filtro a atravesar; el espejo revela devenir. RéZonans: capta; el espejo traduce en forma simbólica. Instantáneo múltiple: superpone; el espejo difracta. Superposición: analítica; el espejo es más intuitivo. Sujet pluriel: estructura; el espejo revela. Experiencia fragmentada / Stratification: estructuran capas; el espejo refleja sin fijar. Mirto decisivo: el espejo puede preparar un giro alineado." }],
      word_notes: ["Número guía 31: expresión/creación (3) + iniciativa/eje (1)—“reflejos estructurantes” que vuelven legible lo emergente.", "Principio: reconocer el devenir por eco y correspondencia, no por inventario fijo.", "Cadena operativa: Illusion evita la proyección, RéZonans capta, Aliœvolution integra, Péroptissimisme transmuta; Instantáneo múltiple y Superposición abren la lectura."],
      cta_translate: "Proponer una traducción del concepto"
    }
  };

  function fb(lang){ return FALLBACK[normLang(lang)] || FALLBACK.fr; }

  function renderFromLexicon(root, lang){
    var rawId = root.getAttribute("data-po-lex-id") || "miroirs_posoennoiaux";
    var id = clampStr(rawId).trim();
    var eMain =
      getLexiconEntry(id) ||
      getLexiconEntry("miroirs_posoennoiaux") ||
      getLexiconEntry("miroirs-posoennoiaux") ||
      getLexiconEntry("miroirs_posœnnoïaux") ||
      getLexiconEntry("miroirs-posœnnoïaux") ||
      getLexiconEntry("miroirs_posoennoiaux_31");

    var F = fb(lang);
    var titleFR = (eMain ? pickTermFR(eMain) : "") || FALLBACK.fr.title;
    setSlotText(root, "title", titleFR);

    setSlotImgSrc(root, "title_img", CHIP_CONCEPT_URL, titleFR);

    var kicker = eMain ? clampStr(pickAny(eMain, "kicker_" + lang, "")) : "";
    if (!kicker && eMain) kicker = clampStr(pickAny(eMain, "kicker_fr", ""));
    setSlotHTML(root, "kicker", kicker || F.kicker);

    setSlotText(root, "h_def", F.h_def);
    setSlotText(root, "chip_1", F.chips[0]);
    setSlotText(root, "chip_2", F.chips[1]);
    setSlotText(root, "chip_3", F.chips[2]);

    setSlotImgSrc(root, "chip_1_img", CHIP_CONCEPT_URL, F.chips[0]);
    setSlotImgSrc(root, "chip_2_img", CHIP_FUNCTION_URL, F.chips[1]);
    setSlotImgSrc(root, "chip_3_img", CHIP_GUIDE_URL, F.chips[2]);

    setSlotText(root, "h_features", F.h_features);
    setSlotText(root, "h_questions", F.h_questions);
    setSlotText(root, "hint_fold", F.hint_fold);
    setSlotText(root, "hint_fold2", F.hint_fold);
    setSlotText(root, "h_family", F.h_family);
    setSlotText(root, "h_wordbuild", F.h_wordbuild);
    setSlotText(root, "hint_fold3", F.hint_fold);
    setSlotText(root, "cta_translate", F.cta_translate);

    var defS = eMain ? (pickDefShort(eMain, lang) || pickDefShort(eMain, "fr")) : "";
    var defL = eMain ? (pickDefLong(eMain, lang) || pickDefLong(eMain, "fr")) : "";
    setSlotText(root, "def_short", defS || F.def_short);
    setSlotHTML(root, "def_long", "<p>" + clampStr(defL || F.def_long).replace(/\n+/g, "</p><p>") + "</p>");

    var feats = eMain ? pickArray(eMain, lang, "characteristics") : [];
    var ques  = eMain ? pickArray(eMain, lang, "usage_questions") : [];
    renderListInto(root, "features", feats.length ? feats : F.features);
    renderListInto(root, "questions", ques.length ? ques : F.questions);

    var example = eMain ? clampStr(pickAny(eMain, "example_" + lang, "")) : "";
    if (!example && eMain) example = clampStr(pickAny(eMain, "example_fr", ""));
    example = example || F.example;
    setSlotHTML(root, "example_box", "<div><strong>" + F.example_title + "</strong> " + example + "</div>");

    setSlotHTML(root, "family_1", F.family_1);
    setSlotHTML(root, "family_2", F.family_2);
    renderWordBlocks(root, "wordbuild_blocks", F.word_blocks);
    renderListInto(root, "wordbuild_notes", F.word_notes);
    return !!eMain;
  }

  function applyLangEverywhere(lang){
    lang = storeLang(lang);
    CANONICAL_TERMS = getCanonicalProtectTerms();
    var blocks = getTargetRoots();
    for (var i=0;i<blocks.length;i++){
      var root = blocks[i];
      setPressed(root, lang);
      bindLangButtons(root);
      renderFromLexicon(root, lang);
      ensureAudioButtons(root, lang);
    }
    refreshAudioButtons();
    notifyLocaleChanged();
  }

  function init(){
    applyLangEverywhere(getLang());
    if (!(window.PO_LEXICON_MAP || window.PO_LEXICON)){
      var tries = 0;
      var timer = setInterval(function(){
        tries++;
        if (window.PO_LEXICON_MAP || (Array.isArray(window.PO_LEXICON) && window.PO_LEXICON.length)){
          clearInterval(timer);
          applyLangEverywhere(getLang());
        }
        if (tries > 80) clearInterval(timer);
      }, 100);
    }
  }

  window.addEventListener("po:lexicon-ready", function(){
    CANONICAL_TERMS = getCanonicalProtectTerms();
    applyLangEverywhere(getLang());
  });

  function watchHtmlLang(){
    if (!document || !document.documentElement || !window.MutationObserver) return;
    var last = getLang();
    var mo = new MutationObserver(function(){
      var now = getLang();
      if (now !== last){ last = now; applyLangEverywhere(now); }
    });
    try{ mo.observe(document.documentElement, { attributes: true, attributeFilter: ["lang"] }); }catch(e){}
  }

  if (document.readyState === "loading"){
    document.addEventListener("DOMContentLoaded", function(){ init(); watchHtmlLang(); });
  } else {
    init();
    watchHtmlLang();
  }

  window.addEventListener("beforeunload", function(){ stopAudio(); });

  window.PoAxisMiroirsPosoennoiauxTextsFR_EN_ES_20260202 = {
    init: init,
    setLang: applyLangEverywhere,
    getLang: getLang,
    normLang: normLang,
    stopAudio: stopAudio
  };
})();
